/**
 * Reads the build-time content snapshot written by `scripts/prepare-content.js`.
 *
 * Requests are same-origin and relative, so they resolve both in the browser
 * and inside react-snap's headless Chrome. Pages load the snapshot first so the
 * prerendered HTML contains real content, then refresh from the API at runtime.
 *
 * Every helper resolves to `null` rather than throwing: a missing snapshot must
 * degrade to the live API path, never break the page.
 */
const SNAPSHOT_BASE = `${process.env.PUBLIC_URL || ''}/content`;

async function readSnapshot(relativePath) {
  try {
    const response = await fetch(`${SNAPSHOT_BASE}${relativePath}`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    // A missing file falls through to the SPA shell, which is HTML, not JSON.
    return await response.json();
  } catch {
    return null;
  }
}

export function fetchBlogIndexSnapshot() {
  return readSnapshot('/blog-index.json');
}

export function fetchBlogPostSnapshot(slug) {
  if (!slug) return Promise.resolve(null);
  return readSnapshot(`/blog/${encodeURIComponent(slug)}.json`);
}

export function fetchLearnSnapshot() {
  return readSnapshot('/learn.json');
}
